var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 46.75C18.0125 46.75 19.25 45.5125 19.25 44V30.25C19.25 28.7375 18.0125 27.5 16.5 27.5C14.9875 27.5 13.75 28.7375 13.75 30.25V44C13.75 45.5125 14.9875 46.75 16.5 46.75Z",
    fill: "#FFDE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 46.75C34.5125 46.75 35.75 45.5125 35.75 44V30.25C35.75 28.7375 34.5125 27.5 33 27.5C31.4875 27.5 30.25 28.7375 30.25 30.25V44C30.25 45.5125 31.4875 46.75 33 46.75Z",
    fill: "#FFDE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.63 15.565L35.475 3.98747C33.935 3.21747 32.0925 3.21747 30.5525 3.98747L7.37 15.565C6.215 16.1425 5.5 17.325 5.5 18.59C5.5 20.4875 7.0125 22 8.91 22H57.1175C58.9875 22 60.5 20.4875 60.5 18.59C60.5 17.325 59.785 16.1425 58.63 15.565Z",
    fill: "#FFDE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 55C5.5 56.5125 6.7375 57.75 8.25 57.75H39.6C39.0225 55.99 38.72 54.1475 38.61 52.25H8.25C6.7375 52.25 5.5 53.4875 5.5 55Z",
    fill: "#FFDE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.25 33.715V30.25C52.25 28.7375 51.0125 27.5 49.5 27.5C47.9875 27.5 46.75 28.7375 46.75 30.25V36.465L52.25 33.715Z",
    fill: "#FFDE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7625 39.105L45.5125 43.23C44.5775 43.6975 44 44.66 44 45.705V51.0125C44 57.9425 48.7025 64.4325 55 66C61.2975 64.4325 66 57.9425 66 51.0125V45.705C66 44.66 65.4225 43.6975 64.4875 43.2575L56.2375 39.1325C55.4675 38.72 54.5325 38.72 53.7625 39.105ZM51.095 55.825L48.895 53.625C48.0975 52.8275 48.0975 51.5075 48.895 50.71C49.6925 49.9125 51.0125 49.9125 51.81 50.71L53.02 51.92L58.19 46.8325C58.9875 46.035 60.3075 46.035 61.105 46.8325C61.9025 47.63 61.9025 48.95 61.105 49.7475L54.9725 55.825C53.9 56.8975 52.1675 56.8975 51.095 55.825Z",
    fill: "#FFDE33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.0d707ecbc0924743e78c729829242bad.svg";
export { ForwardRef as ReactComponent };